import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import JoditEditor from "jodit-react";
import apiClient from "../../apiClient";
import "./style.css";
import FileUploader from "../blog/FileUploader";

const LandiingPageAdd = () => {
  const navigate = useNavigate();
  const editor = useRef(null);

  const [input, setInput] = useState({
    metaTitle: "",
    metaDescription: "",
    metaKeywords: "",
    pageTitle: "",
    pageSubDescription: "",
    pageContent: "",
    pageSlug: "",
    status: 0,
    category: "",
    subCategory: "",
  });

  const [faqs, setFaqs] = useState([{ q: "", a: "" }]);

  const handleChange = (index, field, value) => {
    const updated = [...faqs];
    updated[index][field] = value;
    setFaqs(updated);
  };

  const addFaq = () => {
    setFaqs([...faqs, { q: "", a: "" }]);
  };

  const removeFaq = (index) => {
    const updated = faqs.filter((_, i) => i !== index);
    setFaqs(updated);
  };


  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
  let errors = {};

  if (!input.category.trim()) {
    errors.category = "Category is required";
  }

  if (!input.subCategory.trim()) {
    errors.subCategory = "Sub Category is required";
  }

  if (!input.metaTitle.trim()) {
    errors.metaTitle = "Meta Title is required";
  }

  if (!input.pageSlug.trim()) {
    errors.pageSlug = "Slug is required";
  }

  // Category and slug can not be same
  if (
    input.category &&
    input.pageSlug &&
    input.category.trim().toLowerCase() ===
      input.pageSlug.trim().toLowerCase()
  ) {
    errors.pageSlug =
      "Page slug can not be same as category";
  }

  // Sub category and slug can not be same
  if (
    input.subCategory &&
    input.pageSlug &&
    input.subCategory.trim().toLowerCase() ===
      input.pageSlug.trim().toLowerCase()
  ) {
    errors.pageSlug =
      "Page slug can not be same as sub category";
  }

  if (!input.pageTitle.trim()) {
    errors.pageTitle = "Page title is required";
  }

  if (!input.metaDescription.trim()) {
    errors.metaDescription =
      "Meta description is required";
  }

  if (!input.metaKeywords.trim()) {
    errors.metaKeywords =
      "Meta keywords are required";
  }

  setFormError(errors);

  return Object.keys(errors).length === 0;
};


  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "category") {
      setInput({
        ...input,
        category: value,
        subCategory: "", // reset
      });
    } else {
      setInput({
        ...input,
        [name]: value,
      });
    }
};

  const config = {
    readonly: false,
    height: 500,
  };

  const saveNewJob = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      const filteredFaqs = faqs.filter(f => f.q && f.a);
      await apiClient.post("/landing", {...input, faqs:filteredFaqs});
      navigate("/landing");
    } catch (error) {
      console.error("Error adding job:", error?.response?.data?.message
      );
    }
    setLoading(false);
  };

  const categoryData = [
    {
      name: "Calculator",
      value: "calculators"
    },
    {
      name: "PDF Tools",
      value: "pdf-tools"
    },
    {
      name: "Image Tools",
      value: "image-tools"
    },
  ]

  const subCategoryData = {
    calculators: [
      { name: "Sip Calculator", value: "sip-calculator" },
      { name: "Step Up Sip Calculator", value: "step-up-sip-calculator" },
      { name: "Lumpsum Calculator", value: "lumpsum-calculator" },
      { name: "Fd Calculator", value: "fd-calculator" },
      { name: "Rd Calculator", value: "rd-calculator" },
      { name: "Ppf Calculator", value: "ppf-calculator" },
      { name: "Epf Calculator", value: "epf-calculator" },
      { name: "Nps Calculator", value: "nps-calculator" },
      { name: "Cagr Calculator", value: "cagr-calculator" },
      { name: "Inflation Calculator", value: "inflation-calculator" },
      { name: "Swp Calculator", value: "swp-calculator" },
      { name: "Emi Calculator", value: "emi-calculator" },
      { name: "Home Loan Emi Calculator", value: "home-loan-emi-calculator" },
      { name: "Personal Loan Emi Calculator", value: "personal-loan-emi-calculator" },
      { name: "Car Loan Emi Calculator", value: "car-loan-emi-calculator" },
      { name: "Education Loan Emi Calculator", value: "education-loan-emi-calculator" },
      { name: "Simple Interest Calculator", value: "simple-interest-calculator" },
      { name: "Compound Interest Calculator", value: "compound-interest-calculator" },
      { name: "Percentage Calculator", value: "percentage-calculator" },
      { name: "Age Calculator", value: "age-calculator" },
      { name: "Bmi Calculator", value: "bmi-calculator" },
      { name: "Date Difference Calculator", value: "date-difference-calculator" },
      { name: "Time Duration Calculator", value: "time-duration-calculator" },
      { name: "Fuel Cost Calculator", value: "fuel-cost-calculator" },
    ],

    "pdf-tools": [
      { name: "Merge Pdf", value: "merge-pdf" },
      { name: "Split Pdf", value: "split-pdf" },
      { name: "Pdf To Jpg", value: "pdf-to-jpg" },
      { name: "Pdf To Png", value: "pdf-to-png" },
      { name: "Image To Pdf", value: "image-to-pdf" },
      { name: "Rotate Pdf", value: "rotate-pdf" },
      { name: "Reorder Pdf", value: "reorder-pdf" },
      { name: "Remove Pdf Pages", value: "remove-pdf-pages" },
      { name: "Extract Pdf Pages", value: "extract-pdf-pages" },
    ],

    "image-tools": [
      { name: "Image Compressor", value: "image-compressor" },
      { name: "Image Resizer", value: "image-resizer" },
      { name: "Image Converter", value: "image-converter" },
      { name: "Image Cropper", value: "image-cropper" },
      { name: "Webp Converter", value: "webp-converter" },
      { name: "Reduce Image Size", value: "reduce-image-size" },
      { name: "Image To Base64", value: "image-to-base64" },
      { name: "Image Color Picker", value: "image-color-picker" },
    ],
  };
  return (
    <>
      <FileUploader />
      <div className="container my-5">
        <div className="card shadow-lg">
          <div className="card-header bg-primary text-white">
            <h3 className="mb-0">New Landing Page Add</h3>
          </div>
          <div className="card-body">
            <div className="row g-3">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Category</label>
                  <small className="form-text text-muted">Defines the category of the Landing page.</small>
                  <select name="category" value={input.category} onChange={handleInputChange} className="form-control">
                    <option value="">Select Category</option>
                    {categoryData.map((res) => (
                      <option key={res.value} value={res.value}>{res.name}</option>
                    ))}
                  </select>
                  {formError.category && <div className="text-danger">{formError.category}</div>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Sub Category</label>
                  <small className="form-text text-muted">Defines the sub category of the Landing page.</small>
                  <select name="subCategory" value={input.subCategory} onChange={handleInputChange} className="form-control">
                    <option value="">Select Sub Category</option>
                    {subCategoryData[input.category]?.map((res) => (
                      <option key={res.value} value={res.value}>{res.name}</option>
                    ))}
                  </select>
                  {formError.subCategory && <div className="text-danger">{formError.subCategory}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Meta Title</label>
                  <small className="form-text text-muted">Represents the headline of the job post.</small>
                  <input type="text" name="metaTitle" value={input.metaTitle} onChange={handleInputChange} className="form-control" />
                  {formError.metaTitle && <div className="text-danger">{formError.metaTitle}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Slug</label>
                  <small className="form-text text-muted">SEO-friendly URL identifier.</small>
                  <input type="text" name="pageSlug" value={input.pageSlug} onChange={handleInputChange} className="form-control" onBlur={() => {
                    setInput({
                      ...input,
                      pageSlug: input.pageSlug.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, ''),
                    });
                  }} />
                  {formError.pageSlug && <div className="text-danger">{formError.pageSlug}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Page Title</label>
                  <small className="form-text text-muted">Appears as the title in search engine results.</small>
                  <input type="text" name="pageTitle" value={input.pageTitle} onChange={handleInputChange} className="form-control" />
                  {formError.pageTitle && <div className="text-danger">{formError.pageTitle}</div>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Page Sub Description</label>
                  <small className="form-text text-muted">Appears as the title in search engine results.</small>
                  <input type="text" name="pageSubDescription" value={input.pageSubDescription} onChange={handleInputChange} className="form-control" />
                  {formError.pageSubDescription && <div className="text-danger">{formError.pageSubDescription}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Meta Description</label>
                  <small className="form-text text-muted">Summarizes the content for search engines.</small>
                  <input type="text" name="metaDescription" value={input.metaDescription} onChange={handleInputChange} className="form-control" />
                  {formError.metaDescription && <div className="text-danger">{formError.metaDescription}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Meta Keywords</label>
                  <small className="form-text text-muted">Keywords to improve search ranking.</small>
                  <input type="text" name="metaKeywords" value={input.metaKeywords} onChange={handleInputChange} className="form-control" />
                  {formError.metaKeywords && <div className="text-danger">{formError.metaKeywords}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Status</label>
                  <small className="form-text text-muted">Indicates whether the post is status or inactive.</small>
                  <select name="status" value={input.status} onChange={handleInputChange} className="form-control">
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>FAQs</label>
                  <small className="form-text text-muted">Add multiple FAQ</small>

                  {faqs.map((faq, index) => (
                    <div key={index} style={{ marginBottom: "15px" }}>
                      <input
                        type="text"
                        placeholder="Question"
                        value={faq.q}
                        onChange={(e) => handleChange(index, "q", e.target.value)}
                        style={{ width: "100%", marginBottom: "5px" }}
                      />

                      <textarea
                        placeholder="Answer"
                        value={faq.a}
                        onChange={(e) => handleChange(index, "a", e.target.value)}
                        style={{ width: "100%" }}
                      />

                      <button type="button" onClick={() => removeFaq(index)}>
                        Remove
                      </button>
                    </div>
                  ))}

                  <button type="button" onClick={addFaq}>
                    Add FAQ
                  </button>

                </div>
              </div>

              <div className="col-12">
                <div className="form-group">
                  <label>Landing Page Content</label>
                  <small className="form-text text-muted">Detailed content about the Tool.</small>
                  <JoditEditor config={config} ref={editor} value={input.pageContent} onBlur={(newContent) => setInput({ ...input, pageContent: newContent })} />
                </div>
              </div>

              <div className="col-12 text-center">
                <button onClick={() => saveNewJob()} disabled={loading} className="btn btn-primary btn-lg">
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandiingPageAdd;